import React, { Component } from 'react';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';

import PrimaryButton from '../../components/PrimaryButton';
import Checkbox from '../../components/Checkbox';

class CreateCertificate extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            phone: '',
            loading: true,
            formLoading: false,
        }

        firebase.database().ref(`/users/${firebase.auth().currentUser.uid}`).once('value')
            .then(snapshot => this.setState({ 
                phone: snapshot.val().phone,
                loading: false,
            }));
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({ formLoading: true });

        const requestTan = firebase
            .functions()
            .httpsCallable('requestTan');

        requestTan({
            phone: this.state.phone,
        }).then(() => {
            this.props.history.push('/dashboard/tan')
            this.setState({ formLoading: false })
        });
    }

    render() {
        const { user } = this.props;
        const { loading, formLoading } = this.state;

        return (
            <div className='modal'>
                <form className='modal__content' onSubmit={this.onSubmit}>
                    <div className='modal__title'>
                        <h2>Anlage des Zertifikats</h2>
                    </div>
                    {loading && (
                        <div className='modal__body' style={{ textAlign: 'center'}}>
                            <div class="lds-ring lds-ring--blue"><div></div><div></div><div></div><div></div></div>
                        </div>
                    )}
                    {!loading && (
                        <>
                            <div className='modal__body'>
                                <p>
                                    Uns liegen folgende Daten zur Ihrer Person zur Legitimierung vor.
                                    Bitte bestätigen Sie die Richtigkeit der hier aufgelisteten Daten.
                                </p>
                                <ul>
                                    <li>Name: {user.displayName}</li>
                                    <li>Anschrift: An der Theresienwiese 1, 80336 München</li>
                                    <li>E-Mail: {user.email}</li>
                                    <li>Mobilnummer: {this.state.phone}</li>
                                </ul>
                                <Checkbox disabled={formLoading} name='currentData' required>
                                    Hiermit bestätige ich die Aktualität der hier aufgelisteten Daten
                                </Checkbox>
                                <p>
                                    Die Registrierung wird durch einen Service des bank-verlag abgewickelt.
                                    Um mit dem Kreditvergabeprozess fortzufahren müssen Sie den
                                    Allgemeinen Geschäftsbedingungen des bank-verlag und einer Weitergabe
                                    Ihrer Daten zur Verarbeitung zustimmen.
                                </p>
                                <Checkbox disabled={formLoading} name='agb' required>
                                    Ich akzeptiere die <a target='_blank' rel="noopener noreferrer" href='https://www.bank-verlag.de/index.php?id=21'>Allgemeinen Geschäftsbedingungen</a>
                                </Checkbox>
                                <Checkbox disabled={formLoading} name='dataTransmission' required>
                                    Hiermit stimme ich der Weitergabe meiner Daten zu
                            </Checkbox>
                            </div>
                            <div class='modal__footer'>
                                <PrimaryButton
                                    title='Daten aktualisieren'
                                    disabled
                                />
                                <PrimaryButton
                                    loadingInside={formLoading}
                                    loading={formLoading}
                                    title='Registrierungs-TAN anfordern'
                                    type='submit'
                                />
                            </div>
                        </>
                    )}
                </form>
            </div>
        );
    }
}

export default CreateCertificate;
